import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden pt-20">
      {/* Vídeo real do CONECTAR em loop — fundo do herói */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/hero-video.mp4"
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
      />

      {/* Escurece sutilmente por cima do vídeo pra garantir leitura do texto
          branco em qualquer cena (algumas são bem claras/ensolaradas). */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/15 to-black/55" aria-hidden="true" />

      <div className="relative z-10 text-center px-4 py-16">
        <h1 className="fade-in-up stagger-1 text-5xl md:text-7xl font-bold text-white leading-[1.05]">
          Conectar
        </h1>
        <p className="fade-in-up stagger-2 font-sans text-lg md:text-2xl font-medium text-white/95 mt-2">
          Comunicação, Aprendizagem e Autonomia em um único aplicativo.
        </p>

        <p className="fade-in-up stagger-3 font-body text-sm md:text-base text-white/85 leading-relaxed mt-5 max-w-xl mx-auto">
          Plataforma de tecnologia assistiva desenvolvida para apoiar professores, estudantes,
          pesquisadores e famílias por meio da Comunicação Aumentativa e Alternativa,
          inteligência artificial e acompanhamento do desenvolvimento.
        </p>

        <div className="fade-in-up stagger-4 flex flex-wrap items-center justify-center gap-3 mt-8">
          <Link
            to="/recursos"
            className="font-sans font-bold text-[15px] px-7 py-3.5 rounded-full bg-primary text-white hover:bg-primary/90 transition-transform hover:-translate-y-0.5"
          >
            Ver projeto
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
